import { atom } from "recoil";
import { definitions } from "../../common-fetch/generated/orders-model-api";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export type LookupPricingState = definitions["PricingInformationDto"][];

export const lookupPricingAtom = atom<LookupPricingState>({
    key: RecoilKeys.LookupPricing,
    default: [],
});
